import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAnalytics } from "use-analytics";
import PageContent from "~/client/components/PageContent";
import PageHeading from "~/client/components/PageHeading";
import { Paragraph } from "./styled";
const NotFoundPage = () => {
    const analytics = useAnalytics();
    useEffect(() => {
        analytics.page({ title: "Not Found" });
    }, [analytics]);
    return (_jsxs(PageContent, { children: [_jsx(PageHeading, { children: "Page Not Found" }), _jsx("div", { children: _jsx(Paragraph, { children: "The requested page or resource was not found." }) })] }));
};
export default NotFoundPage;
